import { __awaiter, __generator } from "tslib";
import { getAdContext } from 'shared/utils/adContext';
import { values, debug } from 'shared/utils';
export function siteInfoLoader() {
    return __awaiter(this, void 0, void 0, function () {
        var adContext, retrieveSiteInfo, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    adContext = getAdContext();
                    if (adContext.dsp_name !== 'gam') {
                        return [2 /*return*/];
                    }
                    if (
                    // No Site Logo Symbols were used.
                    !values(window.ADAPT.ad.symbols).some(function (symbol) { return symbol.type === 'siteLogo'; }) &&
                        // No PacakgeName is available to determine the site domain.
                        !adContext.package_name) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "owned" */ './siteInfo')];
                case 2:
                    retrieveSiteInfo = (_a.sent()).retrieveSiteInfo;
                    return [4 /*yield*/, retrieveSiteInfo()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    // Failures do not cause the rest of Adapt scripts to halt.
                    debug(e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
